import { IGetObraServicoDropDownUseCase } from "../../../presentation/useCases/read/get_obra_servico_drop_down_use_case";
import { ObraServicoDropDown } from "../../models/obra_servico_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraServicoDropDownUseCase
 */

export class GetObraServicoDropDownUseCase implements IGetObraServicoDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraServicoDropDown(
    idObra: number,
  ): Promise<ObraServicoDropDown[]> {
    return await this.repository.getObraServicoDropDown(idObra);
  }
}
